import { render, staticRenderFns } from "./ItemPriceCalculationRevised.vue?vue&type=template&id=83bdf2b4&scoped=true"
import script from "./ItemPriceCalculationRevised.vue?vue&type=script&lang=js"
export * from "./ItemPriceCalculationRevised.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83bdf2b4",
  null
  
)

export default component.exports